import React, { Component } from 'react';
import './emergencySet.less';
import { meshLog, SPGet, SPSet } from "../../../../utils/spUtils";
import PubSub from 'pubsub-js'
import btn_on1 from "../../../../imgs/btn/btn_on.png";
import btn_off1 from "../../../../imgs/btn/btn_off.png";
import Manual_Test from "../../../../imgs/item/Manual_Test.png";
import emergency from "../../../../imgs/item/emergency.png";
import light_normal3 from "../../../../imgs/mesh/light_normal3.png";
import montion from "../../../../imgs/item/montion.png";
import arrow_right from "../../../../imgs/btn/arrow_right.png";
import eye_show from "../../../../imgs/btn/eye_show.png";
import wifi_4 from "../../../../imgs/mesh/wifi_4.png";
import wifi_0 from "../../../../imgs/mesh/wifi_0.png";
import { sendOpcode_group_light, sendOpcode_identify, sendOpcode_devices_state, sendOpcode_group_onoff } from '../../../../utils/opcodeUtils';
import { getDevicesByGroupId } from '../../../../utils/meshUtils';
import { SET_ControlPageDetailPage_DIALOG_HIDE, SPIN_DIALOG_SHOW, SPIN_DIALOG_HIDE, } from "../../../../const/infoConst"
import { IsEmergencyDevice } from '../../../../utils/pidUtils';


export default class EmergencySet extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOn: false,
            dimLevel: 50,
            groupInfo: '',
            checked: false, //group是否展开
            devices: [], //group数据
            monthlyTest: false,
            annualTest: false,


        }
    }

    componentDidMount() {
        this.updateGroupUI();
        PubSub.subscribe('updateGroupdataUI', (msg, data) => {
            this.updateGroupUI();
        })

        meshLog('更新灯的状态',);
        PubSub.unsubscribe("mqttDeviceState")
        PubSub.subscribe('mqttDeviceState', (msg, index) => {
            //状态更新
            this.updateGroupUI();
        })
    }



    updateGroupUI() {
        const groupInfo = JSON.parse(SPGet("groupInfo"))
        this.setState({
            groupInfo: groupInfo,
            dimLevel: groupInfo.dimLevel,
            // groupDevices: groupDevices,
            //isOn: false,
            devices: getDevicesByGroupId(groupInfo.groupID), //group数据
        })

        //更新sensor界面的布局,要从数据库先判断有没有这个场景 查找4305的sceneMode，在找到对应的groupid 在看sceneValue（1 2 3 ）对应15 30  90 repeatMode代表周一 周二  repeatWeek代表隔几周

    }

    //原本的处理方法

    handleChange1 = (key, value) => {
        //边输入边赋值
        meshLog('value', value);
        meshLog('key', key);
        this.setState({ [key]: value });

    };

    handleMouseUp = (key, value) => {
        //边输入边赋值 鼠标离开发指令，主要是针对调光调色
        meshLog('handleMouseUphandleMouseUp', value);
        sendOpcode_group_light(key, value);
    };


    monthlyTestClick(key) {
        let diff = this.state.monthlyTest;
        this.setState({
            monthlyTest: !diff,
        })
        //执行方法
        sendOpcode_group_light(key, diff);
    };

    annualTestClick(key) {
        let diff = this.state.annualTest;
        this.setState({
            annualTest: !diff,
        })
        //执行方法  sendOpcode_group_onoff(key);
    };

    onoffClick(key) {
        let diff = this.state.isOn;
        this.setState({
            isOn: !diff,
        })
        sendOpcode_group_onoff(key);

        PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
        setTimeout(() => {
            PubSub.publish(SPIN_DIALOG_HIDE, '');
        }, 2000)

    };

    //group下面跳转
    gotoEmergencySetDevice = () => {
        PubSub.publish('gotoEmergencySetDevice', '')//显示EmergencySetDevice界面
    }

    controlPageDetailContainer = (device) => {
        SPSet('controlDevice', JSON.stringify(device))
        PubSub.publish(SET_ControlPageDetailPage_DIALOG_HIDE, device)//控制ControlPageDetailPage弹框显示
    }

    emergencyRefreshDevices = () => {
        //获取单灯的状态，通过网关来返回的
        sendOpcode_devices_state()
        meshLog('获取单灯的状态',);
    }


    render() {
        const { isOn, dimLevel, monthlyTest, annualTest } = this.state;

        return (
            <div className="emer-container">

                {/* 组名和电源按钮 */}
                <div className="group-header">
                    <div className="action-title">
                        <img src={light_normal3} />
                        <span>{this.state.groupInfo.name}</span>
                    </div>
                </div>
                {/* Dim Level */}
                {/* <div className="dim-level">
                    <div className="label">emergency power</div>
                    <div className="value-boxes">
                        <div className="box">{dimLevel}%</div>
                    </div>
                </div> */}
                {/* Dim滑动条 */}
                {/* <input type="range"
                    min="0"
                    max="100"
                    value={dimLevel}
                    className="slider"
                    onMouseUp={(e) => this.handleMouseUp('dimLevel', parseInt(e.target.value))}
                    onChange={(e) => this.handleChange1('dimLevel', parseInt(e.target.value))} /> */}
                {/* CCT Tunable */}


                <div className="group-header">
                    <div className="action-title">
                        {/* <img className='icon' src={emergency} /> */}
                        <span>Manual Test</span>
                    </div>
                    <img className="onoff-icon" src={isOn ? Manual_Test : Manual_Test} onClick={() => this.onoffClick('EmergencyTest')} />
                </div>

                <div className="group-header">
                    <div className="action-title">
                        {/* <img className='icon' src={emergency} /> */}
                        <span>Monthly Test</span>
                    </div>
                    <img className="onoff-icon" src={monthlyTest ? btn_on1 : btn_off1} onClick={() => this.monthlyTestClick('monthlyTest')} />

                </div>

                <div className="group-header">
                    <div className="action-title">
                        {/* <img className='icon' src={emergency} /> */}
                        <span>Annual Test</span>
                    </div>
                    <img className="onoff-icon" src={annualTest ? btn_on1 : btn_off1} onClick={() => this.annualTestClick('annualTest')} />
                </div>



                <div className="line_space"></div>


                {/* 灯数据 */}
                <div className="device-header" onClick={() => { this.gotoEmergencySetDevice() }} >
                    <div className="action-title">
                        <img className='icon' src={emergency} />
                        <span>Single Device Control</span>
                    </div>

                    <div className="action-group">

                        <img className="arrow-icon" src={arrow_right} />
                    </div>
                </div>
                <div className='devices' style={{ display: this.state.checked ? "flex" : "none" }}>
                    {this.state.devices.map((device) => (
                        <div key={device.macAddress} style={{ display: IsEmergencyDevice(device.pid) ? "flex" : "none" }} className="device_item">
                            <div className='device_left'>
                                <img className='device_icon' src={montion} />
                                <span onClick={() => { this.controlPageDetailContainer(device) }} >{device.name}</span>
                            </div>
                            <div className='device_right'>
                                <img className='device_eye' onClick={() => { this.showHightLight(device) }} src={eye_show} />
                                <img className='device_sign' src={device.online == 1 ? wifi_4 : wifi_0} />
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        );
    }
}
